import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/utils/styled.tsx
import React, { forwardRef } from "react";
var mergeProps = (baseProps, propsToMerge) => ({
  ...baseProps,
  ...propsToMerge
});
var splitVariantProps = (variantKeys, props) => {
  const variantProps = {};
  const otherProps = {};
  for (const [key, value] of Object.entries(props)) {
    if (variantKeys.includes(key)) {
      variantProps[key] = value;
      continue;
    }
    otherProps[key] = value;
  }
  return [variantProps, otherProps];
};
var styled = (Component, recipe, defaultProps) => {
  const Comp = forwardRef((allProps, ref) => {
    const { unstyled, ...props } = allProps;
    const [variantProps, otherProps] = splitVariantProps(recipe.variantKeys, {
      ...defaultProps,
      ...props
    });
    const classNames = recipe(variantProps);
    const componentProps = mergeProps(otherProps, {
      className: props.unstyled ? props.className : cn(classNames, props.className)
    });
    return /* @__PURE__ */ React.createElement(Component, { ...componentProps, ref });
  });
  Comp.displayName = Component.displayName || Component.name;
  return Comp;
};

export {
  styled
};
